var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAlertDefault = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#9FA2B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00042 11.1496C7.53097 11.1496 7.15042 11.5302 7.15042 11.9996C7.15042 12.4691 7.53097 12.8496 8.00042 12.8496C8.46986 12.8496 8.85042 12.4691 8.85042 11.9996C8.85042 11.5302 8.46986 11.1496 8.00042 11.1496ZM8.90039 3.76119C8.90039 3.3408 8.51983 3 8.05039 3C7.58095 3 7.20039 3.3408 7.20039 3.76119L7.20039 8.23881C7.20039 8.6592 7.58095 9 8.05039 9C8.51983 9 8.90039 8.6592 8.90039 8.23881L8.90039 3.76119Z",
    fill: "#F0F1F7"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertDefault, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert-default.1c0faafb.svg";
export { ForwardRef as ReactComponent };